<template>
  <div class="VideoView">
    <div class="video-box">
      <video
        ref="video"
        class="video"
        :src="video_obj.full_path"
        @pause="is_stop = true"
        @play="is_stop = false"
        @click="play()"
      />
      <div v-if="is_stop" class="play" @click.stop="play()" />
      <div class="computed">
        <div class="time">视频时长：{{ video_obj.duration }}</div> 
        <!-- <div class="time" /> -->
        <!-- <div class="change" @click="getRandomVideo(act_id)">
          <img class="icon_s" src="../../assets/video/Refresh.png">换一换
        </div> -->
        <div class="change" />
        <div class="download" @click="downloadVideo(video_obj)">
          下载视频
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'VideoView',
  data() {
    return {
      is_stop: true,
      Copywriting_list: [],
      video_obj: {
        full_path: '',
        duration: '00:50'
      },
      // is_copy: 0,
      is_copy: null,
      act_id: null,
      isLink: true
    }
  },

  mounted() {
    this.init()
  },

  methods: {
    // 获取活动id
    init() {
      const video_obj = JSON.parse(this.$route.query.video_obj)
      console.log(video_obj, 'video_obj')
      this.video_obj = video_obj
    },

    // 下载视频
    async downloadVideo(videoItem) {
      if (this.isLink === true) {
        this.isLink = false
        try {
          const videoUrl = videoItem.upload.full_path // 替换为实际视频URL
          const response = await fetch(videoUrl)

          if (!response.ok) {
            throw new Error('网络响应不正常')
          }

          const blob = await response.blob()
          const url = window.URL.createObjectURL(blob)
          const a = document.createElement('a')
          a.href = url
          a.download = videoItem.upload.name // 设置下载的文件名
          document.body.appendChild(a)
          a.click()
          document.body.removeChild(a)
          window.URL.revokeObjectURL(url)
          // 下载视频记录
          // getDownloadVideo({ id: this.act_id, video_id: videoItem.id }).then(res => {
          //   console.log(res, 'res')
          //   // this.$toast('视频下载成功！')
          // })
        } catch (err) {
          console.error('下载失败:', err)
        } finally {
        //
        }
        setTimeout(() => {
          this.isLink = true
        }, 3000)
      } else {
        this.$toast('请稍后再试')
      }
    },

    // 播放视频
    play() {
      if (this.is_stop) {
        this.$refs.video.play()
      } else {
        this.$refs.video.pause()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.VideoView {
  width: 100%;
  min-height: 100vh;
  background: #f5f5f5;
  font-size: 14px;
  color: #333;
  position: absolute;
  /* padding-bottom: constant(safe-area-inset-bottom) !important;
    padding-bottom: env(safe-area-inset-bottom) !important; */
}
.video-box {
  width: 355px;
  height: 240.09px;
  background-color: #ffffff;
  border-radius: 7.5px;
  overflow: hidden;
  margin: 12px auto 0;
  position: relative;
}
.content_box {
  width: 355px;
  height: 170px;
  background-color: #ffffff;
  border-radius: 7.5px;
  overflow: hidden;
  margin: 10px auto 0;
  position: relative;
}
.steps_box {
  width: 355px;
  height: 123px;
  background-color: #ffffff;
  border-radius: 7.5px;
  overflow: hidden;
  margin: 10px auto 0;
  position: relative;
  margin-bottom: 20px;
}
.video {
  width: 317.51px;
  height: 178.5px;
  background-color: #000000;
  margin: 16px 18px 0 18px;
  border-radius: 5px;
}
.play {
  width: 50px;
  height: 50px;
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  position: absolute;
  top: 44%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
  background-image: url("../../assets/video/play.png");
}
.computed {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 8px 22px;
}
.time {
  color: #212121;
  font-size: 14px;
  font-weight: Regular;
  width: 60px;
}
.change {
  color: #666666;
  font-size: 12px;
  display: flex;
  align-items: center;
}
.icon_s {
  width: 14.5px;
  height: 12px;
}
.download {
  width: 83.5px;
  height: 29.5px;
  background-image: url("../../assets/video/btn_bg_two.png");
  background-repeat: no-repeat;
  background-size: cover;
  color: #ffffff;
  font-size: 12px;
  font-weight: Bold;
  display: flex;
  align-items: center;
  justify-content: center;
}
.title_s {
  color: #212121;
  font-size: 14px;
  font-weight: Bold;
  text-align: left;
  margin: 7px 0 13px 17px;
}
.names {
  width: 222px;
  color: #666666;
  font-size: 12px;
  font-weight: Regular;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow: ellipsis;
  text-align: left;
}
.button_x {
  color: #ffffff;
  font-size: 9px;
  background-image: url("../../assets/video/btn_bg.png");
  background-repeat: no-repeat;
  background-size: cover;
  width: 55.5px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.button_y {
  color: #ffffff;
  font-size: 9px;
  background: linear-gradient(90deg, #ff9c5a 0%, #ff5151 60%);
  background-repeat: no-repeat;
  background-size: cover;
  width: 55.5px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 9.77px;
}
.copy {
  // width: 317.38px;
  width: 335px;
  height: 40px;
  background-color: #f8f8f8;
  display: flex;
  justify-content: space-between;
  margin: 8px 9px;
  border-radius: 5px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 14px;
}
.change {
  color: #666666;
  font-size: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.icon_s {
  width: 14.5px;
  height: 12px;
}
.steps {
  text-align: left;
  margin-left: 16px;
  color: #333333;
  font-size: 13px;
}
</style>
